/** 我们的照片 — assets/ourPhotos 按分类目录 */

const ALL_TAB_PHOTOS = [
  require("@/assets/ourPhotos/All/1-1.jpg"),
  require("@/assets/ourPhotos/All/1-2.jpg"),
  require("@/assets/ourPhotos/All/1-3.jpg"),
  require("@/assets/ourPhotos/All/1-4.jpg"),
  require("@/assets/ourPhotos/All/1-5.jpg"),
  require("@/assets/ourPhotos/All/1-6.jpg"),
];

const PHOTOS_BY_CATEGORY = {
  hotel: [
    require("@/assets/ourPhotos/partnerHotels/1-1.jpg"),
    require("@/assets/ourPhotos/partnerHotels/1-2.jpg"),
    require("@/assets/ourPhotos/partnerHotels/1-3.jpg"),
  ],
  vehicle: [
    require("@/assets/ourPhotos/tourVehicles/1-1.jpg"),
    require("@/assets/ourPhotos/tourVehicles/1-2.jpg"),
    require("@/assets/ourPhotos/tourVehicles/1-3.jpg"),
  ],
  office: [
    require("@/assets/ourPhotos/companyEnvironment/1-1.jpg"),
    require("@/assets/ourPhotos/companyEnvironment/1-2.jpg"),
    require("@/assets/ourPhotos/companyEnvironment/1-3.jpg"),
  ],
  team: [
    require("@/assets/ourPhotos/staffGroupPhotos/1-1.jpg"),
    require("@/assets/ourPhotos/staffGroupPhotos/1-2.jpg"),
    require("@/assets/ourPhotos/staffGroupPhotos/1-3.jpg"),
  ],
};

/** @deprecated 请使用 getOurPhotosByTab，保留以兼容旧引用 */
export const DEST_DETAIL_GALLERY = [
  ...ALL_TAB_PHOTOS,
  ...PHOTOS_BY_CATEGORY.hotel,
  ...PHOTOS_BY_CATEGORY.vehicle,
  ...PHOTOS_BY_CATEGORY.office,
  ...PHOTOS_BY_CATEGORY.team,
];

/** 按 tab 键（all / hotel / vehicle / office / team）返回照片列表 */
export function getOurPhotosByTab(tab) {
  if (tab === "all") {
    return ALL_TAB_PHOTOS.map((src) => ({ src }));
  }
  const imgs = PHOTOS_BY_CATEGORY[tab] || [];
  return imgs.map((src) => ({ src, category: tab }));
}
